var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceFloor01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 653.86 163.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcf76d;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38 {\n        mix-blend-mode: multiply;\n        opacity: .5;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-39 {\n        isolation: isolate;\n      }\n\n      .cls-40 {\n        fill: #fc8b4f;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-41 {\n        fill: #fccc4f;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-43 {\n        fill: #fcae4f;\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2820.36,
    y1: 159.42,
    x2: 2820.36,
    y2: -43.95,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#390180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#380481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#371084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#34248a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#314093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2c639e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#278fab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21c2bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1edcc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4164.39,
    y1: 3437.91,
    x2: 4195.37,
    y2: 3735.6,
    gradientTransform: "translate(3694.72 4258.39) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6000a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8b25f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00abff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4125.24,
    y1: 3513.77,
    x2: 4152.58,
    y2: 3776.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4129.7,
    y1: 3548.84,
    x2: 4139.95,
    y2: 3647.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4220.49,
    y1: 3512.82,
    x2: 4233.13,
    y2: 3634.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 4188.78,
    y1: 3531.33,
    x2: 4193.04,
    y2: 3572.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 4231.24,
    y1: 3587.42,
    x2: 4235.19,
    y2: 3625.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 4124.72,
    y1: 3475.72,
    x2: 4140.69,
    y2: 3629.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 4108.78,
    y1: 3582.84,
    x2: 4118.01,
    y2: 3671.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 4205.68,
    y1: 3540.92,
    x2: 4226.4,
    y2: 3739.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1014.81,
    y1: -3026.67,
    x2: 1045.8,
    y2: -2728.98,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 975.67,
    y1: -2950.81,
    x2: 1003,
    y2: -2688.17,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 980.13,
    y1: -2915.74,
    x2: 990.38,
    y2: -2817.29,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1070.91,
    y1: -2951.77,
    x2: 1083.56,
    y2: -2830.26,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1039.21,
    y1: -2933.25,
    x2: 1043.47,
    y2: -2892.28,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1081.67,
    y1: -2877.17,
    x2: 1085.62,
    y2: -2839.2,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 975.14,
    y1: -2988.86,
    x2: 991.11,
    y2: -2835.42,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 959.2,
    y1: -2881.74,
    x2: 968.43,
    y2: -2793.06,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1056.11,
    y1: -2923.66,
    x2: 1076.83,
    y2: -2724.63,
    gradientTransform: "translate(1272.28 2938.28) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2729.12,
    y1: 83.48,
    x2: 2789.34,
    y2: 83.48,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2673.29,
    y1: 43.58,
    x2: 2729.48,
    y2: 43.58,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2740.21,
    y1: 38.81,
    x2: 2761.1,
    y2: 38.81,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2762.81,
    y1: 130.59,
    x2: 2787.93,
    y2: 130.59,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2794.03,
    y1: 94.94,
    x2: 2802.26,
    y2: 94.94,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2739.71,
    y1: 137.38,
    x2: 2747.56,
    y2: 137.38,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2779.19,
    y1: 37.32,
    x2: 2811.93,
    y2: 37.32,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2712.79,
    y1: 17.51,
    x2: 2731.27,
    y2: 17.51,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2687.44,
    y1: 121.33,
    x2: 2728.52,
    y2: 121.33,
    gradientTransform: "translate(3147.29) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2252.84,
    y1: 6566.64,
    x2: -2221.85,
    y2: 6864.33,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -2291.99,
    y1: 6642.5,
    x2: -2264.65,
    y2: 6905.14,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -2287.52,
    y1: 6677.57,
    x2: -2277.28,
    y2: 6776.02,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -2196.74,
    y1: 6641.54,
    x2: -2184.09,
    y2: 6763.05,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -2228.45,
    y1: 6660.06,
    x2: -2224.18,
    y2: 6701.03,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -2185.98,
    y1: 6716.14,
    x2: -2182.03,
    y2: 6754.11,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -2292.51,
    y1: 6604.45,
    x2: -2276.54,
    y2: 6757.89,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -2308.45,
    y1: 6711.57,
    x2: -2299.22,
    y2: 6800.25,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -2211.54,
    y1: 6669.65,
    x2: -2190.83,
    y2: 6868.68,
    gradientTransform: "translate(2806.59 6820.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M0,0h653.86v163.47H20C8.96,163.47,0,154.5,0,143.47V0H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.42,76.74c-1.3-1.16-1.6-3.28-.74-4.85,3.01-5.49,5.89-11.05,8.64-16.68.53-1.09,1.47-1.74,2.49-1.73,7.9.07,15.8-.42,23.68-1.45.97-.13,1.91.36,2.52,1.31,6.66,10.43,13.87,20.48,21.63,30.05,1.08,1.32,1.03,3.46-.14,4.91-4.58,5.68-9.35,11.2-14.32,16.53-1.06,1.13-2.63,1.42-3.88.71-14.3-8.14-27.64-17.84-39.89-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M72.68,109.2c1.34,1.63,1.12,4.12-.53,5.33-8.59,7.13-35.63,24.03-43.93,27.35-1.25.62-2.84.34-4.05-.7-1.8-1.55-3.58-3.11-5.34-4.71-1.02-.92-1.56-2.24-1.45-3.49,1.01-11.22,2.08-22.43,3.22-33.62.18-1.75,1.5-2.93,3.11-2.82,12.31.83,24.47.47,36.41-1.01,1.12-.14,2.25.38,2.99,1.38,3.09,4.18,6.29,8.28,9.58,12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M104.6,122.9c.61.95.74,2.16.34,3.27-.87,2.37-1.76,4.74-2.67,7.1-.6,1.56-2.16,2.54-3.77,2.35-3.78-.43-7.54-.97-11.28-1.6-2.08-.35-3.36-2.48-2.79-4.53.99-3.56,1.96-7.12,2.9-10.69.19-.73.59-1.37,1.15-1.85,1.7-1.46,3.39-2.95,5.05-4.46,1.57-1.42,3.91-1.08,5.01.73,1.98,3.26,4,6.48,6.06,9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M108.09,33.49c-.94-.82-1.39-2.34-1.13-3.81.44-2.47.86-4.93,1.27-7.4.22-1.31.95-2.36,1.89-2.71,3.02-1.14,6.01-2.37,8.97-3.69.7-.31,1.47-.2,2.11.31,3.06,2.46,6.2,4.83,9.4,7.1.94.66,1.5,2.03,1.39,3.48-.43,5.96-.93,11.93-1.5,17.9-.24,2.57-2.48,4.1-4.24,2.89-6.32-4.35-12.38-9.05-18.16-14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M139.08,71.66c-.71-.36-.92-2.56-.98-4.32-.04-1.4.61-2.75,1.65-3.49.59-.42,1.18-.84,1.77-1.27,1.88-1.36,4.17-.15,4.43,2.37.12,1.22.24,2.44.36,3.66.27,2.65-1.98,4.95-4.13,4.22-1.37-.47-2.62-.94-3.1-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M90.52,28.09c-1.03.99-2,1.87-2.4,2.16-.61.45-2.06-.59-3.15-1.55-.86-.76-1.3-2.15-1.15-3.52.09-.78.17-1.57.26-2.35.28-2.51,2.27-3.86,3.86-2.63.77.6,1.55,1.19,2.33,1.78,1.69,1.27,1.86,4.56.26,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M124.06,143.11c-.26-2.98-.52-5.95-.78-8.93-.07-.79.13-1.61.55-2.32,4.2-7.05,8.19-14.23,11.95-21.52.39-.75.98-1.36,1.69-1.74,2.39-1.28,4.76-2.6,7.12-3.97,1.72-1,3.7-.39,4.42,1.38,2.19,5.39,4.43,10.75,6.73,16.08.29.67.35,1.46.17,2.25-1.2,5.24-2.47,10.46-3.81,15.68-.41,1.61-1.79,2.92-3.4,3.21-7.03,1.29-14.05,2.23-21.07,2.83-1.87.16-3.41-1.13-3.57-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M57.45,144.91c1.11-1.62,2.22-3.24,3.31-4.88.34-.5.8-.9,1.35-1.16,1.59-.76,3.18-1.53,4.75-2.33,1.65-.83,3.72-.22,4.74,1.41,1.04,1.66,2.09,3.32,3.15,4.97.98,1.51.73,3.49-.62,4.64-2.14,1.82-4.31,3.61-6.5,5.37-1.2.96-2.93,1.02-4.29.16-1.58-1-3.16-2.02-4.72-3.06-1.77-1.18-2.28-3.5-1.16-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M53.97,16.04c.23.11.45.27.65.47,5.3,5.28,10.85,10.28,16.65,14.96,1.33,1.07,1.74,3.41.86,5.13-6.1,11.89-12.82,23.44-20.16,34.55-.54.82-1.38,1.29-2.28,1.28-4.08-.05-8.18-.23-12.3-.56-1.54-.12-2.84-1.59-3.03-3.41-1.19-11.16-2.13-22.32-2.84-33.45-.04-.64.05-1.28.27-1.85,2.68-7.07,5.25-14.19,7.74-21.36.6-1.73,2.06-2.49,3.33-1.75,3.65,2.13,7.36,4.13,11.11,5.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M240.2,94c-1.16,1.3-3.28,1.6-4.85.74-5.49-3.01-11.05-5.89-16.68-8.64-1.09-.53-1.74-1.47-1.73-2.49.07-7.9-.42-15.8-1.45-23.68-.13-.97.36-1.91,1.31-2.52,10.43-6.66,20.48-13.87,30.05-21.63,1.32-1.08,3.46-1.03,4.91.14,5.68,4.58,11.2,9.35,16.53,14.32,1.13,1.06,1.42,2.63.71,3.88-8.14,14.3-17.84,27.64-28.79,39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.67,95.74c1.63-1.34,4.12-1.12,5.33.53,7.13,8.59,24.03,35.63,27.35,43.93.62,1.25.34,2.84-.7,4.05-1.55,1.8-3.11,3.58-4.71,5.34-.92,1.02-2.24,1.56-3.49,1.45-11.22-1.01-22.43-2.08-33.62-3.22-1.75-.18-2.93-1.5-2.82-3.11.83-12.31.47-24.47-1.01-36.41-.14-1.12.38-2.25,1.38-2.99,4.18-3.09,8.28-6.29,12.3-9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M286.37,63.82c.95-.61,2.16-.74,3.27-.34,2.37.87,4.74,1.76,7.1,2.67,1.56.6,2.54,2.16,2.35,3.77-.43,3.78-.97,7.54-1.6,11.28-.35,2.08-2.48,3.36-4.53,2.79-3.56-.99-7.12-1.96-10.69-2.9-.73-.19-1.37-.59-1.85-1.15-1.46-1.7-2.95-3.39-4.46-5.05-1.42-1.57-1.08-3.91.73-5.01,3.26-1.98,6.48-4,9.68-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.96,60.33c-.82.94-2.34,1.39-3.81,1.13-2.47-.44-4.93-.86-7.4-1.27-1.31-.22-2.36-.95-2.71-1.89-1.14-3.02-2.37-6.01-3.69-8.97-.31-.7-.2-1.47.31-2.11,2.46-3.06,4.83-6.2,7.1-9.4.66-.94,2.03-1.5,3.48-1.39,5.96.43,11.93.93,17.9,1.5,2.57.24,4.1,2.48,2.89,4.24-4.35,6.32-9.05,12.38-14.06,18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.12,29.34c-.36.71-2.56.92-4.32.98-1.4.04-2.75-.61-3.49-1.65-.42-.59-.84-1.18-1.27-1.77-1.36-1.88-.15-4.17,2.37-4.43,1.22-.12,2.44-.24,3.66-.36,2.65-.27,4.95,1.98,4.22,4.13-.47,1.37-.94,2.62-1.18,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M191.56,77.89c.99,1.03,1.87,2,2.16,2.4.45.61-.59,2.06-1.55,3.15-.76.86-2.15,1.3-3.52,1.15-.78-.09-1.57-.17-2.35-.26-2.51-.28-3.86-2.27-2.63-3.86.6-.77,1.19-1.55,1.78-2.33,1.27-1.69,4.56-1.86,6.1-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M306.57,44.36c-2.98.26-5.95.52-8.93.78-.79.07-1.61-.13-2.32-.55-7.05-4.2-14.23-8.19-21.52-11.95-.75-.39-1.36-.98-1.74-1.69-1.28-2.39-2.6-4.76-3.97-7.12-1-1.72-.39-3.7,1.38-4.42,5.39-2.19,10.75-4.43,16.08-6.73.67-.29,1.46-.35,2.25-.17,5.24,1.2,10.46,2.47,15.68,3.81,1.61.41,2.92,1.79,3.21,3.4,1.29,7.03,2.23,14.05,2.83,21.07.16,1.87-1.13,3.41-2.95,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M308.37,110.96c-1.62-1.11-3.24-2.22-4.88-3.31-.5-.34-.9-.8-1.16-1.35-.76-1.59-1.53-3.18-2.33-4.75-.83-1.65-.22-3.72,1.41-4.74,1.66-1.04,3.32-2.09,4.97-3.15,1.51-.98,3.49-.73,4.64.62,1.82,2.14,3.61,4.31,5.37,6.5.96,1.2,1.02,2.93.16,4.29-1,1.58-2.02,3.16-3.06,4.72-1.18,1.77-3.5,2.28-5.12,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M179.51,114.45c.11-.23.27-.45.47-.65,5.28-5.3,10.28-10.85,14.96-16.65,1.07-1.33,3.41-1.74,5.13-.86,11.89,6.1,23.44,12.82,34.55,20.16.82.54,1.29,1.38,1.28,2.28-.05,4.08-.23,8.18-.56,12.3-.12,1.54-1.59,2.84-3.41,3.03-11.16,1.19-22.32,2.13-33.45,2.84-.64.04-1.28-.05-1.85-.27-7.07-2.68-14.19-5.25-21.36-7.74-1.73-.6-2.49-2.06-1.75-3.33,2.13-3.65,4.13-7.36,5.99-11.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416.95,85.7c1.3,1.16,1.6,3.28.74,4.85-3.01,5.49-5.89,11.05-8.64,16.68-.53,1.09-1.47,1.74-2.49,1.73-7.9-.07-15.8.42-23.68,1.45-.97.13-1.91-.36-2.52-1.31-6.66-10.43-13.87-20.48-21.63-30.05-1.08-1.32-1.03-3.46.14-4.91,4.58-5.68,9.35-11.2,14.32-16.53,1.06-1.13,2.63-1.42,3.88-.71,14.3,8.14,27.64,17.84,39.89,28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M418.69,53.24c-1.34-1.63-1.12-4.12.53-5.33,8.59-7.13,35.63-24.03,43.93-27.35,1.25-.62,2.84-.34,4.05.7,1.8,1.55,3.58,3.11,5.34,4.71,1.02.92,1.56,2.24,1.45,3.49-1.01,11.22-2.08,22.43-3.22,33.62-.18,1.75-1.5,2.93-3.11,2.82-12.31-.83-24.47-.47-36.41,1.01-1.12.14-2.25-.38-2.99-1.38-3.09-4.18-6.29-8.28-9.58-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M386.76,39.53c-.61-.95-.74-2.16-.34-3.27.87-2.37,1.76-4.74,2.67-7.1.6-1.56,2.16-2.54,3.77-2.35,3.78.43,7.54.97,11.28,1.6,2.08.35,3.36,2.48,2.79,4.53-.99,3.56-1.96,7.12-2.9,10.69-.19.73-.59,1.37-1.15,1.85-1.7,1.46-3.39,2.95-5.05,4.46-1.57,1.42-3.91,1.08-5.01-.73-1.98-3.26-4-6.48-6.06-9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M383.28,128.94c.94.82,1.39,2.34,1.13,3.81-.44,2.47-.86,4.93-1.27,7.4-.22,1.31-.95,2.36-1.89,2.71-3.02,1.14-6.01,2.37-8.97,3.69-.7.31-1.47.2-2.11-.31-3.06-2.46-6.2-4.83-9.4-7.1-.94-.66-1.5-2.03-1.39-3.48.43-5.96.93-11.93,1.5-17.9.24-2.57,2.48-4.1,4.24-2.89,6.32,4.35,12.38,9.05,18.16,14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.28,90.78c.71.36.92,2.56.98,4.32.04,1.4-.61,2.75-1.65,3.49-.59.42-1.18.84-1.77,1.27-1.88,1.36-4.17.15-4.43-2.37-.12-1.22-.24-2.44-.36-3.66-.27-2.65,1.98-4.95,4.13-4.22,1.37.47,2.62.94,3.1,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M400.84,134.34c1.03-.99,2-1.87,2.4-2.16.61-.45,2.06.59,3.15,1.55.86.76,1.3,2.15,1.15,3.52-.09.78-.17,1.57-.26,2.35-.28,2.51-2.27,3.86-3.86,2.63-.77-.6-1.55-1.19-2.33-1.78-1.69-1.27-1.86-4.56-.26-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M367.31,19.33c.26,2.98.52,5.95.78,8.93.07.79-.13,1.61-.55,2.32-4.2,7.05-8.19,14.23-11.95,21.52-.39.75-.98,1.36-1.69,1.74-2.39,1.28-4.76,2.6-7.12,3.97-1.72,1-3.7.39-4.42-1.38-2.19-5.39-4.43-10.75-6.73-16.08-.29-.67-.35-1.46-.17-2.25,1.2-5.24,2.47-10.46,3.81-15.68.41-1.61,1.79-2.92,3.4-3.21,7.03-1.29,14.05-2.23,21.07-2.83,1.87-.16,3.41,1.13,3.57,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M433.91,17.53c-1.11,1.62-2.22,3.24-3.31,4.88-.34.5-.8.9-1.35,1.16-1.59.76-3.18,1.53-4.75,2.33-1.65.83-3.72.22-4.74-1.41-1.04-1.66-2.09-3.32-3.15-4.97-.98-1.51-.73-3.49.62-4.64,2.14-1.82,4.31-3.61,6.5-5.37,1.2-.96,2.93-1.02,4.29-.16,1.58,1,3.16,2.02,4.72,3.06,1.77,1.18,2.28,3.5,1.16,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M437.4,146.39c-.23-.11-.45-.27-.65-.47-5.3-5.28-10.85-10.28-16.65-14.96-1.33-1.07-1.74-3.41-.86-5.13,6.1-11.89,12.82-23.44,20.16-34.55.54-.82,1.38-1.29,2.28-1.28,4.08.05,8.18.23,12.3.56,1.54.12,2.84,1.59,3.03,3.41,1.19,11.16,2.13,22.32,2.84,33.45.04.64-.05,1.28-.27,1.85-2.68,7.07-5.25,14.19-7.74,21.36-.6,1.73-2.06,2.49-3.33,1.75-3.65-2.13-7.36-4.13-11.11-5.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M571.01,71.22c1.16-1.3,3.28-1.6,4.85-.74,5.49,3.01,11.05,5.89,16.68,8.64,1.09.53,1.74,1.47,1.73,2.49-.07,7.9.42,15.8,1.45,23.68.13.97-.36,1.91-1.31,2.52-10.43,6.66-20.48,13.87-30.05,21.63-1.32,1.08-3.46,1.03-4.91-.14-5.68-4.58-11.2-9.35-16.53-14.32-1.13-1.06-1.42-2.63-.71-3.88,8.14-14.3,17.84-27.64,28.79-39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M538.55,69.47c-1.63,1.34-4.12,1.12-5.33-.53-7.13-8.59-24.03-35.63-27.35-43.93-.62-1.25-.34-2.84.7-4.05,1.55-1.8,3.11-3.58,4.71-5.34.92-1.02,2.24-1.56,3.49-1.45,11.22,1.01,22.43,2.08,33.62,3.22,1.75.18,2.93,1.5,2.82,3.11-.83,12.31-.47,24.47,1.01,36.41.14,1.12-.38,2.25-1.38,2.99-4.18,3.09-8.28,6.29-12.3,9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M524.84,101.4c-.95.61-2.16.74-3.27.34-2.37-.87-4.74-1.76-7.1-2.67-1.56-.6-2.54-2.16-2.35-3.77.43-3.78.97-7.54,1.6-11.28.35-2.08,2.48-3.36,4.53-2.79,3.56.99,7.12,1.96,10.69,2.9.73.19,1.37.59,1.85,1.15,1.46,1.7,2.95,3.39,4.46,5.05,1.42,1.57,1.08,3.91-.73,5.01-3.26,1.98-6.48,4-9.68,6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M614.25,104.88c.82-.94,2.34-1.39,3.81-1.13,2.47.44,4.93.86,7.4,1.27,1.31.22,2.36.95,2.71,1.89,1.14,3.02,2.37,6.01,3.69,8.97.31.7.2,1.47-.31,2.11-2.46,3.06-4.83,6.2-7.1,9.4-.66.94-2.03,1.5-3.48,1.39-5.96-.43-11.93-.93-17.9-1.5-2.57-.24-4.1-2.48-2.89-4.24,4.35-6.32,9.05-12.38,14.06-18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.09,135.88c.36-.71,2.56-.92,4.32-.98,1.4-.04,2.75.61,3.49,1.65.42.59.84,1.18,1.27,1.77,1.36,1.88.15,4.17-2.37,4.43-1.22.12-2.44.24-3.66.36-2.65.27-4.95-1.98-4.22-4.13.47-1.37.94-2.62,1.18-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M619.65,87.32c-.99-1.03-1.87-2-2.16-2.4-.45-.61.59-2.06,1.55-3.15.76-.86,2.15-1.3,3.52-1.15.78.09,1.57.17,2.35.26,2.51.28,3.86,2.27,2.63,3.86-.6.77-1.19,1.55-1.78,2.33-1.27,1.69-4.56,1.86-6.1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M504.64,120.86c2.98-.26,5.95-.52,8.93-.78.79-.07,1.61.13,2.32.55,7.05,4.2,14.23,8.19,21.52,11.95.75.39,1.36.98,1.74,1.69,1.28,2.39,2.6,4.76,3.97,7.12,1,1.72.39,3.7-1.38,4.42-5.39,2.19-10.75,4.43-16.08,6.73-.67.29-1.46.35-2.25.17-5.24-1.2-10.46-2.47-15.68-3.81-1.61-.41-2.92-1.79-3.21-3.4-1.29-7.03-2.23-14.05-2.83-21.07-.16-1.87,1.13-3.41,2.95-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M502.84,54.25c1.62,1.11,3.24,2.22,4.88,3.31.5.34.9.8,1.16,1.35.76,1.59,1.53,3.18,2.33,4.75.83,1.65.22,3.72-1.41,4.74-1.66,1.04-3.32,2.09-4.97,3.15-1.51.98-3.49.73-4.64-.62-1.82-2.14-3.61-4.31-5.37-6.5-.96-1.2-1.02-2.93-.16-4.29,1-1.58,2.02-3.16,3.06-4.72,1.18-1.77,3.5-2.28,5.12-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M631.7,50.76c-.11.23-.27.45-.47.65-5.28,5.3-10.28,10.85-14.96,16.65-1.07,1.33-3.41,1.74-5.13.86-11.89-6.1-23.44-12.82-34.55-20.16-.82-.54-1.29-1.38-1.28-2.28.05-4.08.23-8.18.56-12.3.12-1.54,1.59-2.84,3.41-3.03,11.16-1.19,22.32-2.13,33.45-2.84.64-.04,1.28.05,1.85.27,7.07,2.68,14.19,5.25,21.36,7.74,1.73.6,2.49,2.06,1.75,3.33-2.13,3.65-4.13,7.36-5.99,11.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.86,30.7c-19.46-.35-48.47-13.2-66.8-13.2-29.64,0-106.36,13.8-117.69,13.8-9.1,0-54.05-16.2-66.26-16.2-12.21,0-60.16,2.4-93.28,4.2-33.13,1.8-98.52,19.2-104.62,19.2-6.1,0-74.1-16.8-90.67-15-16.56,1.8-73.23,14.4-81.08,14.4-4.15,0-19.51-3.52-33.46-6.85V1.8h653.86v28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M653.86,28.9c-19.46-.35-48.47-13.2-66.8-13.2-29.64,0-106.36,13.8-117.69,13.8-9.1,0-54.05-16.2-66.26-16.2-12.21,0-60.16,2.4-93.28,4.2s-98.52,19.2-104.62,19.2c-6.1,0-74.1-16.8-90.67-15-16.56,1.8-73.23,14.4-81.08,14.4-4.15,0-19.51-3.52-33.46-6.85V0h653.86v28.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M125.11,22.02c-4.43-.45-8.09-.6-10.58-.33-16.56,1.8-73.23,14.4-81.08,14.4C33.46,36.1,64.84,14.75,91.33,0h40.17c-1.04,9.29-5.61,20.2-6.39,22.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M87,26.4L126.75,0h3.82c.13.85.29,1.91.47,3.11-1.54,8.47-5.23,17.29-5.93,18.91-4.43-.45-8.09-.6-10.58-.33-5.67.62-16.03,2.5-27.53,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M406.59,12.69l.14.91c-1.4-.2-2.63-.31-3.63-.31-12.21,0-60.16,2.4-93.28,4.2s-98.52,19.2-104.62,19.2C205.2,36.7,242.13,14.76,273.67,0h95.61c20.22,6.38,37.3,12.69,37.3,12.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M309.82,17.49c-4.16.23-8.84.7-13.84,1.35L328.3,0h39.54s5.18,1.19,5.18,1.19c18.54,5.95,33.57,11.5,33.57,11.5l.14.91c-1.4-.2-2.63-.31-3.63-.31-12.21,0-60.16,2.4-93.28,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M205.2,36.7s2.56-1.52,6.89-4.02l12.27.18c-10.1,2.26-17.33,3.84-19.17,3.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M653.86,28.9c-19.46-.35-48.47-13.2-66.8-13.2-29.64,0-106.36,13.8-117.69,13.8C469.36,29.5,503.24,10.66,530.84,0h55.09c29.41,10.51,67.93,28.9,67.93,28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M551.57,18.57C558.68,12.15,567.36,4.83,574.26,0h11.67c29.41,10.51,67.93,28.9,67.93,28.9-19.46-.35-48.47-13.2-66.8-13.2-8.71,0-21.49,1.19-35.48,2.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.97,25.89c-3.49,1.8-57.54-11.4-57.54-11.4L146.04,0h75.63c-5.06,8.53-18.92,24.46-21.7,25.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.97,26.49C27.24,27.43,10.8,23.53,0,20.89V0h48.64c-6.72,10.72-16.44,25.73-18.67,26.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.83,16.29C642.63,15.05,632.42,7.43,623.62,0h30.25v16.43c-1.38.12-2.73.09-4.03-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.14,0c-9.93,6.91-22.75,14.15-30.01,16.29C455.75,18.76,423.56,7.38,404.18,0h89.96Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceFloor01);
export default __webpack_public_path__ + "static/media/SPACE_FLOOR_01.6efc4ee29dd0b9d084be8a8aaa11ae93.svg";
export { ForwardRef as ReactComponent };